const ROUTER_NAME_PREFIX_MY = 'WikiInProfileMy-';
const ROUTER_NAME_PREFIX_USERS = 'WikiInProfileUsers-';

export {ROUTER_NAME_PREFIX_MY, ROUTER_NAME_PREFIX_USERS}